import React, { useLayoutEffect } from 'react';

import {
  isEmptyCollection,
  SiteConfigManager,
  useApplicationState,
  useTranslation,
} from '@atlas/core';

import useTranslate from 'common/I18n/Interpreter';
import { createChat, updateChat } from 'components/LiveChat/LiveChatFactory';

const LiveChatView = () => {
  const applicationState = useApplicationState();
  const isChatAvailable = SiteConfigManager.getConfig(
    'config.config.support.live_chat.desktop.is_available',
  );
  const chatType = SiteConfigManager.getConfig('config.config.support.live_chat.desktop.type');
  const chatParams = SiteConfigManager.getConfig('config.config.support.live_chat.desktop.params');
  const {
    account: { email: accountEmail, firstName: accountName, id: accountId } = {},
    resolved: accountResolved,
  } = applicationState;

  const translate = useTranslate();
  const translation = useTranslation();
  const isTranslationReady = !isEmptyCollection(translation);
  const isInitialized = React.useRef(false);

  useLayoutEffect(() => {
    if (!accountResolved || !isChatAvailable || !isTranslationReady || !chatType || !chatParams) {
      return;
    }

    if (isInitialized.current === true) {
      updateChat(chatType, {
        accountEmail,
        accountId,
        accountName,
        chatParams,
        translate,
      });
    } else {
      createChat(chatType, {
        accountEmail,
        accountId,
        accountName,
        chatParams,
        translate,
      });
      isInitialized.current = true;
    }
  }, [chatParams, isTranslationReady, translation, accountId, accountResolved]);

  return <div id="atlasChat" />;
};

export default LiveChatView;
